import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useConfirmSignup } from "@features/login/signup/useConfirmSignup";
import { CONFIRMATION_EXPIRED_ERROR } from "@features/login/constants";

export const SignupConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const confirmationToken = searchParams.get("confirmationToken");
  const navigate = useNavigate();
  const { mutate: confirmSignup } = useConfirmSignup();

  useEffect(() => {
    if (!confirmationToken) {
      navigate(`/confirmation/email?error=${CONFIRMATION_EXPIRED_ERROR}`);
    } else {
      confirmSignup(
        { confirmationToken },
        {
          onSuccess: () => {
            navigate("/");
          },
          onError: () => {
            navigate(`/confirmation/email?error=${CONFIRMATION_EXPIRED_ERROR}`);
          },
        }
      );
    }
  }, [confirmationToken, confirmSignup, navigate]);

  return <div></div>;
};
